import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useQuery } from 'urql';

import Loader from '../../shared/components/Loader';
import Error from '../components/Error';
import Modal from '../components/Modal';
import { Dispatch, openModal } from '../state';
import Message from './Message';
import Send from './Send';
import { IArgs, IData, IMessage, query } from './query';

function Inbox(): JSX.Element {
    const [open, setOpen] = React.useState<string>('');
    const [replyMessage, setReplyMessage] = React.useState<IMessage | null>(null);
    const dispatch = useDispatch<Dispatch>();
    const [result] = useQuery<IData, IArgs>({
        query,
        variables: { current: true },
    });

    const toggleOpen = React.useCallback((id: string) => {
        setOpen(open => open === id ? '' : id);
    }, [setOpen]);

    const openReply = React.useCallback((message: IMessage) => {
        setReplyMessage(message);
        dispatch(openModal('Messages/Reply'));
    }, []);

    if (result.fetching) {
        return <Loader />;
    } else if (result.error) {
        return <Error />;
    }

    return <section>
        {result.data.messages.map(message => <Message
            key={message.id}
            message={message}
            open={open === message.id}
            toggleOpen={toggleOpen}
            openReply={openReply}
        />)}
        <Modal modal='Messages/Reply'>
            <Send message={replyMessage} />
        </Modal>
    </section>;
}

export default Inbox;
